var _defs, _path, _polyline, _path2, _polyline2, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.12 88.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:8.78px;}.cls-1,.cls-2{fill:none;stroke:#e33563;stroke-miterlimit:10;}.cls-2{stroke-width:.49px;}.cls-3{fill:#f3f253;}.cls-3,.cls-4{stroke-width:0px;}.cls-4{fill:#e33563;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.74,5.85l4.23,51,3.2,28.77-29.39,3.27-.58-5.21,17.61-1.96.35-20.21c-5.72-.62-13.05-3.13-18.63-10.9-10.7-14.88-15.55-40.45-15.55-40.45.74-.08,38.75-4.32,38.75-4.32Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.6 13.08 15.5 15.21 31.42 49.97 48.78 48.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.76,6.96l7.09,50.68,3.2,28.77,29.39-3.27-.58-5.21-17.61,1.96-4.79-19.63c5.45-1.87,12.04-5.93,15.78-14.73,7.16-16.87,6.27-42.88,6.27-42.88-.74.08-38.75,4.32-38.75,4.32Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "87.73 7.16 106.83 5.04 98.94 42.45 81.59 44.38"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "62.07 59.81 94.62 38.73 94.89 45.86 126.96 22.45 90.56 53.7 91.02 43.78 62.07 59.81"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "60.73 59.3 93.28 38.22 93.55 45.35 125.62 21.94 89.22 53.19 89.68 43.27 60.73 59.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.63 58.75 35.24 45.35 36.54 52.36 .11 36.58 42.49 59.05 39.86 49.48 71.63 58.75"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "72.83 57.95 36.43 44.56 37.74 51.57 1.31 35.79 43.69 58.26 41.06 48.69 72.83 57.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.a674e55663049d5e3d5340cfa03ff4ab.svg";
export { ForwardRef as ReactComponent };